import React from 'react'

const StatsCard = () => {
  return (
    <div className="lg:absolute md:absolute left-32 -bottom-12 w-72 bg-white border border-[#fbecf9] shadow-xl rounded-xl bg-opacity-80 overflow-hidden">
      <div className="p-6">
        <h3 className="font-[600] text-xl mb-10 text-center text-[#6540b2]">Monthly payment status</h3>
        <div className="h-48 flex items-end justify-between gap-2">
          {[60, 75, 85, 95,100, 70, 90, 40].map((height, i) => (
            <div key={i} className="relative w-3 bg-[#e83f3b] bg-opacity-35 rounded-t-full" style={{ height: `${height}%` }}>
              <div
                className="absolute bottom-0 w-full bg-[#e83f3b] rounded-t-md transition-all duration-500"
                style={{ height: `${height * 0.8}%` }}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default StatsCard